import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Asynchronously loads the component for InvalidOrg
 *
 */
import Loadable from 'react-loadable';
import PageLoader from '@project/components/Loaders/PageLoader';
export default Loadable({
    loader: function () { return import(/* webpackChunkName: 'InvalidOrg' */ './index'); },
    loading: function (props) {
        if (props.error) {
            console.error(props.error);
        }
        return _jsx(PageLoader, {});
    },
});
